// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datacard {
  width: 100%;
  font-style: italic;
  text-align: center;
  grid-column-start: 1;
  grid-column-end: -1;
}
.datacard h2 {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #353535;
}
.datacard h3 {
  font-size: 14px;
  text-align: center;
  font-weight: 300;
  color: #353535;
}
.datacard p {
  font-size: 16px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/DataCardMessage.less"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AADJ;AAJA;EAQM,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADN;AAVA;EAeM,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAFN;AAhBA;EAqBM,eAAA;EACA,kBAAA;AAFN","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.datacard {\n    width: 100%;\n    font-style: italic;\n    text-align: center;\n    grid-column-start: 1;\n    grid-column-end: -1;\n\n    h2 {\n      text-align: center;\n      font-size: 20px;\n      font-weight: bold;\n      color: @text-gray1;\n    }\n\n    h3 {\n      font-size: 14px;\n      text-align: center;\n      font-weight: 300;\n      color: @text-gray1;\n    }\n    p {\n      font-size: 16px;\n      text-align: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
